var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuildingDouble = function SvgBuildingDouble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    fill: "none",
    viewBox: "0 0 16 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1.74 2a1 1 0 0 1 1-1h5.65a1 1 0 0 1 1 1v14.3H1.74V2ZM14.26 5.48a1 1 0 0 0-1-1H10.4a1 1 0 0 0-1 1V16.3h4.87V5.48Z",
    vectorEffect: "non-scaling-stroke"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.09,
    height: 2.09,
    x: 3.13,
    y: 2.74,
    fill: "currentColor",
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.09,
    height: 2.09,
    x: 3.13,
    y: 5.87,
    fill: "currentColor",
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.09,
    height: 2.09,
    x: 3.13,
    y: 9,
    fill: "currentColor",
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.09,
    height: 2.09,
    x: 3.13,
    y: 12.13,
    fill: "currentColor",
    rx: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.09,
    height: 2.09,
    x: 5.91,
    y: 2.74,
    fill: "currentColor",
    rx: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2.09,
    height: 2.09,
    x: 10.78,
    y: 6.22,
    fill: "currentColor",
    rx: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 2.09,
    height: 2.09,
    x: 5.91,
    y: 5.87,
    fill: "currentColor",
    rx: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 2.09,
    height: 2.09,
    x: 10.78,
    y: 9.35,
    fill: "currentColor",
    rx: 1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 2.09,
    height: 2.09,
    x: 5.91,
    y: 9,
    fill: "currentColor",
    rx: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 2.09,
    height: 2.09,
    x: 10.78,
    y: 12.13,
    fill: "currentColor",
    rx: 1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 2.09,
    height: 2.09,
    x: 5.91,
    y: 12.13,
    fill: "currentColor",
    rx: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1 16h13.65",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgBuildingDouble;